// Entry flows run over several ticks before the page stops moving: applying the
// quick pick query params strips them via a router navigation, re-renders the whole
// play list, and only then scrolls. Waiting for scroll idle alone is not enough —
// with enough plays the quiet window expires before the scroll is even requested.
// Anything that needs to measure a settled page waits on these holds instead.
const pending = ref(0)

export const useEditorSettling = () => {
  const hold = () => {
    pending.value += 1
    let released = false

    return () => {
      if (released) return
      released = true
      pending.value = Math.max(0, pending.value - 1)
    }
  }

  const whenSettled = () =>
    new Promise<void>((resolve) => {
      if (!pending.value) return resolve()

      const stop = watch(
        pending,
        (value) => {
          if (value) return
          stop()
          resolve()
        },
        { flush: 'sync' },
      )
    })

  const reset = () => (pending.value = 0)

  return { hold, reset, whenSettled }
}
